import {FieldType} from "../../manager/FieldType";
import {Accordion} from "./Accordion";
import {attributeGroups} from "./attributeGroups";
import {toolbox} from "./toolbox";
import {FieldTypeManager} from "../../manager/FieldTypeManager";

export const accordionFieldType: FieldType = {
  name: 'accordion',
  component: Accordion,
  attributeGroups: attributeGroups,
  toolbox,
};

FieldTypeManager.register(accordionFieldType.name, accordionFieldType);
